import utils from './utils';

/**
 * The wording for one "this repetition is running out" dashboard warning.
 *
 * Pure, and in its own module rather than beside the component, so the copy can
 * be unit-tested without dragging in the API client (and axios with it). The
 * two branches say quite different things: one is a heads-up with a countdown,
 * the other is "this already stopped and you did not notice".
 */
export const buildRepeatExpiryMessage = (alert) => {
  const period = utils.repeatPeriodLabel(alert.repeat_period);
  const suffix = period ? ` (${period.toLowerCase()})` : '';
  const name = `»${alert.title || 'Brez naziva'}«`;
  const when = utils.formatDt(alert.last_occurrence_date);

  if (alert.is_lapsed) {
    return {
      message: `Ponavljanje ${name}${suffix} se je izteklo ${when}.`,
      description:
        'Od takrat ni bila ustvarjena nobena nova transakcija. ' +
        'Podaljšajte ponavljanje ali potrdite, da je zaključeno.',
    };
  }

  const amount = utils.formatToMoney(alert.amount, true);
  const days = alert.days_left;
  // "čez 0 dni" / "čez 1 dni" both read as broken Slovenian.
  const dayPart =
    days === 0 ? 'je danes' : days === 1 ? 'je jutri' : `je čez ${days} dni`;

  return {
    message: `Ponavljanje ${name}${suffix} se izteče ${when}.`,
    description:
      `Zadnje plačilo (${amount}) ${dayPart}, nato se transakcija ne bo več ` +
      'ponavljala. Podaljšajte ponavljanje, da se nadaljuje.',
  };
};

export default buildRepeatExpiryMessage;
